import { render, staticRenderFns } from "./PhoneView.vue?vue&type=template&id=e27dea8a&scoped=true&"
import script from "./PhoneView.vue?vue&type=script&lang=js&"
export * from "./PhoneView.vue?vue&type=script&lang=js&"
import style0 from "./PhoneView.vue?vue&type=style&index=0&id=e27dea8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27dea8a",
  null
  
)

export default component.exports